"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toBuffer = require('to-buffer');

exports.leftPadBuffer = function (maybeBuffer, length) {
  var zeros = Buffer.allocUnsafe(length).fill(0);
  var buf = exports.toBuffer(maybeBuffer, 'hex');

  if (buf.length < length) {
    buf.copy(zeros, length - buf.length);
    return zeros;
  }

  return buf.slice(-length);
};

exports.intToBuffer = function (n) {
  var hex = n.toString(16);

  if (hex.length % 2) {
    hex = "0".concat(hex);
  }

  return Buffer.from(hex, 'hex');
};

exports.bufferToInt = function (buf) {
  return parseInt(buf.toString('hex'), 16);
};